import types from '../types/afaActionTypes';

export const setInputValue = (name, value) => {
  return { type: types.SET_INPUT_VALUE, payload: { name, value } }
}

export const setAfaDetail = (payload) => {
  return { type: types.SET_AFA_DETAIL, payload }
}

export const resetAfaDetail = (payload) => {
  return { type: types.RESET_AFA_DETAIL, payload }
}

export const setOrganizationAfaData = (payload) => {
  return { type: types.SET_ORGANIZATION_AFA_DATA, payload };
};

export const setMatterAfaData = (payload) => {
  return { type: types.SET_MATTER_AFA_DATA, payload };
};
